import React from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';

import Button from '~/Components/Global/Form/Button';
import Card from '~/Components/Layout/Card/Card';
import { MONTH } from '~/Config/DateRangeTypes';

import { startTrial } from '~/Redux/Modules/Subscription';
import { setMonthType } from '~/Redux/Modules/DateRange';

import './StartTrial.scss';

const StartTrial = ({ startTrial, user, isStartingTrial, monthView, currentMonth }) => (
  <Card noLogo className="video-player">
    <div className="start-trial">
      <h1>Learn about the different layouts in Artful Agenda</h1>
      <iframe
        title="Intro Video"
        src="https://www.youtube.com/embed/yByA4A3MkE8"
        frameBorder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
      {user.trial_ends_at == null ? (
        <Button
          type="button"
          onClick={startTrial}
          className="pill"
          isFetching={isStartingTrial}
          text="ADD MY FIRST CALENDAR"
          actionText="STARTING"
        />
      ) : (
        <Button
          onClick={() => monthView(currentMonth)}
          className="margin-top btn btn-default pill"
          text="START PLANNING!"
        />
      )}
    </div>
  </Card>
);

StartTrial.propTypes = {
  startTrial: propTypes.func,
  isStartingTrial: propTypes.bool,
  user: propTypes.object,
  monthView: propTypes.func,
  currentMonth: propTypes.object,
};

StartTrial.defaultProps = {};

const mapStateToProps = ({ Subscription, User, DateRange }) => {
  return {
    coupon: Subscription.data.coupon,
    name: Subscription.data.name,
    plan: Subscription.data.plan,
    isFetching: Subscription.isFetching,
    isStartingTrial: Subscription.isStartingTrial,
    user: User.data,
    currentMonth: DateRange.start.clone().startOf(MONTH),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    startTrial: () => dispatch(startTrial()),
    monthView: monthStart => dispatch(setMonthType(monthStart.clone())),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StartTrial);
